(function( $ ) {

    $( document ).ready( function() {
        if ($('.seasonal__flight-search').length > 0) {
            const { __, _x, _n, _nx } = wp.i18n;

            const seasonalflightsSearchModule = $('#seasonal_flights_search');
            const seasonalFlightsSearchModuleTrigger = $('#seasonal_flights_search #seasonal_flights_search_module_trigger');
            const seasonalFlightSearchForm = seasonalflightsSearchModule.find( "#seasonal_flights_form" );

            if ( seasonalflightsSearchModule.length > 0 ) {

                seasonalFlightsSearchModuleTrigger.click( function() {

                    $(this).find('.fa-chevron-down').toggleClass('active');

                    seasonalflightsSearchModule.find('#flights_search_form_wrap').slideToggle();
                });

                // Original width and height before resize
                var originalWidth = $(window).width();
                function isKeyboard(width) {
                    if (originalWidth === width) {
                        return true;
                    } else {
                        return false;
                    }
                }
                //on window resize, show/hide items
                $(window).resize(function(){
                    const winWidth = window.innerWidth;
                    let resizedWidth = $(window).width();
                    const seasonalChevronDown = seasonalFlightsSearchModuleTrigger.find('.fa-chevron-down');

                    if ( winWidth > 767 ) {

                        seasonalflightsSearchModule.find('#flights_search_form_wrap').show();

                    } else {

                        if (!(isKeyboard(resizedWidth))) {
                            seasonalflightsSearchModule.find('#flights_search_form_wrap').hide();
                            if (seasonalChevronDown.hasClass('active')) {
                                seasonalChevronDown.removeClass('active');
                            }
                        }

                    }
                });
                
                /**
                 * Destinations List Array
                 */
                var data_dest = seasonalFlightSearchForm.attr('data-dest');
                if (data_dest !== "" && typeof data_dest !== 'undefined') {
                    data_dest = JSON.parse(data_dest);

                    const destinationsList = [];

                    $.each(data_dest, function(index, value) {
                        destinationsList.push(value);
                    });

                    seasonalFlightSearchForm.find("#destination").autocomplete({
                        source: destinationsList,
                        change: function(event, ui) {
                            if (ui.item == null) {
                                event.currentTarget.value = '';
                                event.currentTarget.focus();
                            }
                        }
                    });
                }

                const flight_search_date = seasonalFlightSearchForm.find("#seasonal_flight_search_date");
                flight_search_date.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/mm/yy",
                    minDate: "-3M",
                    maxDate: "+6M",
                    firstDay: 1
                });
                seasonalFlightSearchForm.validate({
                    rules: {
                        seasonal_flight_search_date: {
                            required: true,
                            regexDateFormat: /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/
                        },
                        destination : {
                            required: true,
                        },
                    },
                    submitHandler: function( form ) {
                        form.submit();
                    }
                });

                //regex the flight date
                $.validator.addMethod(
                    "regexDateFormat",
                    function( value, element, regexp ) {
                        const re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                    },
                    __( 'Wrong date format' ,  'sofia-airport' )
                );

                $.extend( $.validator.messages, {
                    required: __( 'The field is required' ,  'sofia-airport' ),
                });
            }
        }
    });
})( jQuery );